export default __webpack_public_path__ + "static/media/List.8f7061ab.svg";